export default __webpack_public_path__ + "static/media/gallery_07.54e06501.jpg";